import { EmptyDashboard, Halflogoicon, Plus } from "assests";
import { Button } from "components/UI/Button";
import usePermission from "hooks/usePermission";

const EmptyComponent = ({
  text,
  buttonText,
  onClick,
  icon,
  permissionText,
  isFromSettings = false,
}) => {
  const { hasPermission } = usePermission();
  return (
    <div className="flex flex-col items-center justify-center max-w-[600px] my-12 mx-auto w-full p-8 rounded-xl bg-global-white">
      <div className="flex flex-col items-center justify-center gap-6">
        <div className="flex items-center justify-center ">
          <div
            className={`bg-white flex items-center justify-center  border border-global-gray-soft w-14 h-14 rounded-xl`}
            style={{
              boxShadow:
                "rgba(16, 24, 40, 0.05) 0px 1px 2px 0px, rgba(1, 24, 50, 0.06) 0px 0px 0px .5px inset, rgba(16, 24, 40, 0.05) 0px -2px 0px 0px inset",
            }}
          >
            <Halflogoicon width={28} height={26} />
          </div>
        </div>
        <p className="text-lg font-semibold  leading-[38px] text-gray-950">{text}</p>
        {isFromSettings ? (
          <>
            {buttonText && (
              <Button
                size="md"
                className="text-center font-semibold text-sm py-2.5 md:py-[11px] whitespace-nowrap "
                onClick={onClick}
              >
                {icon && (
                  <span>
                    <Plus fillColor={`#fff`} className="w-3 h-3" />
                  </span>
                )}
                {buttonText}
              </Button>
            )}
          </>
        ) : (
          permissionText &&
          hasPermission(permissionText) && (
            <>
              {buttonText && (
                <Button
                  size="md"
                  className="text-center font-semibold text-sm py-2.5 md:py-[11px] whitespace-nowrap "
                  onClick={onClick}
                >
                  {icon && (
                    <span>
                      <Plus fillColor={`#fff`} className="w-3 h-3" />
                    </span>
                  )}
                  {buttonText}
                </Button>
              )}
            </>
          )
        )}
      </div>
    </div>
  );
};

export default EmptyComponent;
